import React from 'react';
import {PropTypes} from 'prop-types';
import "./PasswordStrengthIndicator.scss";
import classNames from 'classnames';

const PasswordStrengthIndicator = (props) => {

  let indicatorClass = classNames('hrb-password-strength-indicator', props.strength);
  return (
      <div className={indicatorClass}>
        <div className="hrb-password-strength-level level-one"></div>
        <div className="hrb-password-strength-level level-two"></div>
        <div className="hrb-password-strength-level level-three"></div>
      </div>
  )
};

PasswordStrengthIndicator.propTypes = {
  strength: PropTypes.string
};

export default PasswordStrengthIndicator;